import React from "react";
import { Link, useNavigate } from "react-router-dom";
import { useAuth } from "../context/AuthContext";
import "./Footer.css";

const Footer = () => {
  const { user, logout } = useAuth();
  const navigate = useNavigate();
  const mapsUrl = "https://maps.app.goo.gl/fJPaU6SKVWk4Fa7B8";

  const handleLogout = async () => {
    await logout();
    navigate("/");
  };

  return (
    <footer className="site-footer">
      <div className="footer-container">
        <div className="footer-col">
          <div className="footer-logo">
            <span className="logo-icon">☀</span>
            <span className="logo-text">Sunrise Stationery</span>
          </div>
          <p className="footer-tagline">
            Premium stationery, ready for pickup in just 15-20 minutes.
          </p>
        </div>

        <div className="footer-col">
          <h4>Quick Links</h4>
          <Link to="/">Home</Link>
          <Link to="/orders">My Orders</Link>
          {user ? (
            <button className="footer-link-btn" onClick={handleLogout}>Logout</button>
          ) : (
            <Link to="/login">Login</Link>
          )}
        </div>

        <div className="footer-col">
          <h4>Contact Us</h4>
          <a href="tel:+919646043435" className="footer-contact-item">
            <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2"><path d="M22 16.92v3a2 2 0 0 1-2.18 2 19.79 19.79 0 0 1-8.63-3.07 19.5 19.5 0 0 1-6-6 19.79 19.79 0 0 1-3.07-8.67A2 2 0 0 1 4.11 2h3a2 2 0 0 1 2 1.72c.127.96.361 1.903.7 2.81a2 2 0 0 1-.45 2.11L8.09 9.91a16 16 0 0 0 6 6l1.27-1.27a2 2 0 0 1 2.11-.45c.907.339 1.85.573 2.81.7A2 2 0 0 1 22 16.92z"></path></svg>
            +91 96460 43435
          </a>
          <a href="mailto:sunrise.latestcomputer@gmail.com" className="footer-contact-item">
            <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2"><path d="M4 4h16c1.1 0 2 .9 2 2v12c0 1.1-.9 2-2 2H4c-1.1 0-2-.9-2-2V6c0-1.1.9-2 2-2z"></path><polyline points="22,6 12,13 2,6"></polyline></svg>
            sunrise.latestcomputer@gmail.com
          </a>
          <a
            href={mapsUrl}
            target="_blank"
            rel="noopener noreferrer"
            className="footer-contact-item footer-address-link"
          >
            <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2"><path d="M21 10c0 7-9 13-9 13s-9-6-9-13a9 9 0 0 1 18 0z"></path><circle cx="12" cy="10" r="3"></circle></svg>
            <span>5-A, Daim Ganj, Main Road,<br/>Amritsar, Punjab - 143001</span>
          </a>
        </div>
      </div>

      <div className="footer-bottom">
        <p>&copy; {new Date().getFullYear()} Sunrise Stationery. All rights reserved.</p>
      </div>
    </footer>
  );
};

export default Footer;